import { render, staticRenderFns } from "./ShopInfo.vue?vue&type=template&id=0be09506&scoped=true&"
import script from "./ShopInfo.vue?vue&type=script&lang=js&"
export * from "./ShopInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShopInfo.vue?vue&type=style&index=0&id=0be09506&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be09506",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Administrator\\Desktop\\gtzn\\FreeGoShop\\client_web_food_market\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0be09506', component.options)
    } else {
      api.reload('0be09506', component.options)
    }
    module.hot.accept("./ShopInfo.vue?vue&type=template&id=0be09506&scoped=true&", function () {
      api.rerender('0be09506', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shop/ShopInfo.vue"
export default component.exports